var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplianceRepairIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5351 22.8084H61.6551C61.1636 22.8084 60.7651 23.2068 60.7651 23.6984V26.0084C60.7651 26.4999 61.1636 26.8984 61.6551 26.8984H70.5351C71.0267 26.8984 71.4251 26.4999 71.4251 26.0084V23.6984C71.4251 23.2068 71.0267 22.8084 70.5351 22.8084Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3151 27.0684C50.5351 27.0684 51.5251 26.0784 51.5251 24.8584C51.5251 23.6384 50.5351 22.6484 49.3151 22.6484C48.0951 22.6484 47.1051 23.6384 47.1051 24.8584C47.1051 26.0784 48.0951 27.0684 49.3151 27.0684Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7151 24.1884C29.7151 25.8284 30.8751 27.1584 32.3051 27.1584H36.7051C38.1351 27.1584 39.2951 25.8284 39.2951 24.1884H29.7151Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7451 0.248352C23.1351 0.248352 0.745148 22.6384 0.745148 50.2484C0.745148 77.8584 23.1351 100.248 50.7451 100.248C78.3551 100.248 100.745 77.8584 100.745 50.2484C100.745 22.6384 78.3551 0.248352 50.7451 0.248352ZM50.7451 94.2484C41.5551 94.2484 33.0151 91.4084 25.9451 86.5684L43.0451 68.6084C44.0451 69.0084 45.0951 69.2084 46.1351 69.2084C48.2751 69.2084 50.3751 68.3684 51.9551 66.7984C53.5351 65.2084 54.3951 63.1084 54.3651 60.8584C54.3551 60.4384 54.1051 60.0784 53.7151 59.9184C53.5851 59.8684 53.4551 59.8384 53.3151 59.8384C53.0451 59.8384 52.7751 59.9484 52.5751 60.1484L48.3051 64.3884L43.8951 63.1784L42.7351 58.7584L46.9651 54.5384C47.2651 54.2384 47.3551 53.7884 47.1951 53.3984C47.0351 53.0084 46.6751 52.7584 46.2451 52.7484H46.1051C43.9251 52.7484 41.8651 53.6084 40.3151 55.1584C37.9751 57.4984 37.2651 60.9984 38.4851 64.1184L20.9451 82.5883C12.2251 74.5383 6.74515 63.0284 6.74515 50.2484C6.74515 25.9884 26.4851 6.24835 50.7451 6.24835C75.0051 6.24835 94.7451 25.9884 94.7451 50.2484C94.7451 74.5084 75.0051 94.2484 50.7451 94.2484Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0551 18.9184H28.4351C26.7951 18.9184 25.4651 20.2484 25.4651 21.8884V74.8484L34.1051 65.8184C32.4451 62.9784 31.5051 59.6884 31.5051 56.1784C31.5051 45.5584 40.1251 36.9484 50.7451 36.9484C61.3651 36.9484 69.9851 45.5584 69.9851 56.1784C69.9851 66.7984 61.3651 75.4184 50.7451 75.4184C47.4051 75.4184 44.2751 74.5684 41.5351 73.0684L33.3751 81.5784H73.0551C74.6951 81.5784 76.0251 80.2484 76.0251 78.6084V21.8884C76.0251 20.2484 74.6951 18.9184 73.0551 18.9184ZM73.0551 20.9184C73.5851 20.9184 74.0251 21.3584 74.0251 21.8884V28.7884H43.4651V20.9184H73.0551ZM27.4651 21.8884C27.4651 21.3584 27.9051 20.9184 28.4351 20.9184H41.4651V28.7884H27.4651V21.8884Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9851 56.1784C66.9851 47.2284 59.6951 39.9484 50.7451 39.9484C41.7951 39.9484 34.5051 47.2284 34.5051 56.1784C34.5051 58.7484 35.1051 61.1784 36.1651 63.3384C35.6251 60.9684 35.9251 58.5184 36.9951 56.3984C36.9851 56.3284 36.9851 56.2484 36.9851 56.1784C36.9851 48.5784 43.1451 42.4184 50.7451 42.4184C55.5051 42.4184 59.7051 44.8384 62.1751 48.5184C59.2751 49.9784 57.4751 52.8984 57.4751 56.1784C57.4751 59.4584 59.2751 62.3884 62.1751 63.8484C59.7651 67.4384 55.6951 69.8384 51.0751 69.9384C49.5851 70.7684 47.8951 71.2084 46.1351 71.2084C45.4751 71.2084 44.8151 71.1483 44.1651 71.0183C46.1751 71.9183 48.4051 72.4184 50.7451 72.4184C59.6951 72.4184 66.9851 65.1384 66.9851 56.1784Z",
    fill: "#00FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1720",
    x: 0.0000118613,
    y: -0.0000265539,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1720",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1720"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1720",
    result: "effect3_innerShadow_4857_1720"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplianceRepairIcon);
export default __webpack_public_path__ + "static/media/ApplianceRepairIcon.ebabf7f53368693f27d801a7f859510d.svg";
export { ForwardRef as ReactComponent };